import * as AuthActions from '../actions/user.actions';
import {User} from '../models/user';
import {createReducer, on} from '@ngrx/store';

export interface State {
    isLoggedIn: boolean;
    user: User | null;
    redirectUrl: string | null;
    isPending: boolean;
}

export const initialState: State = {
    isLoggedIn: false,
    user: null,
    redirectUrl: null,
    isPending: false
};

export const reducer = createReducer(
    initialState,
    on(AuthActions.validateAuthToken, state => ({...state, redirectUrl: null, user: null, isPending: true})),
    on(AuthActions.validateAuthTokenInvalid, state => ({...state, isPending: false})),
    on(AuthActions.login, state => ({...state, isLoggedIn: false, user: null, isPending: true})),
    on(AuthActions.validateAuthTokenLoggedIn, AuthActions.loginSuccess, (state, {user}) => {
        return {...state, isLoggedIn: true, user: user, isPending: false};
    }),
    on(AuthActions.loginFailure, state => ({...state, isPending: false})),
    on(AuthActions.logout, (state, {requestedUrl}) => ({...initialState, redirectUrl: requestedUrl})),
    on(AuthActions.accessDenied, (state, {requestedUrl}) => ({...state, redirectUrl: requestedUrl, isPending: false})),
    on(AuthActions.accessGranted, state => ({...state, redirectUrl: '', isPending: false})),
);

export const getIsLoggedIn = (state: State) => state.isLoggedIn;
export const getUser = (state: State) => state.user;
export const getRedirectUrl = (state: State) => state.redirectUrl;
export const getIsPending = (state: State) => state.isPending;
